export const APP_REDUCER_NAME = 'portal'
export const APP_LOGGED_IN_USER_REDUCER_NAME = 'allLoggedInUser'
export const APP_LOGGED_IN_CUSTOMER_REDUCER_NAME = 'allLoggedInCustomer'
export const APP_IS_SIGN_USER_REDUCER_NAME = 'isSigninUser'
export const TENANT_ALL_USERS = 'allTenantUsers'